class StringMemory {
  private readonly storage: Storage;

  private readonly prefix: string;

  constructor(storage: Storage) {
    this.storage = storage;
    this.prefix = 'memory';
  }

  async get<T extends () => string | Promise<string>>(key: string, callback: T) {
    const item = this.storage.getItem(this.getKeyName(key));

    if (item) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log(
          `Fetched key "${key}" correctly, but did not return the stored response. Use production environment to enable.`,
        );

        return callback();
      }

      return item;
    }

    const result = await callback();

    this.storage.setItem(this.getKeyName(key), result);

    return result;
  }

  delete(key: string) {
    this.storage.removeItem(this.getKeyName(key));
  }

  private getKeyName(key: string) {
    return `${this.prefix}-${key}`;
  }
}

export default (storage: Storage) => new StringMemory(storage);
